<vs-card class="mt-8">
  <vs-card-header
    [config]="{
      title: 'Claim Resolution Options',
      subtitle: 'Manage the tenant-specific claim-level resolution values available to your team.',
    }"
  >
    <button *ngIf="canEdit" vs-button slot="end" appearance="outline" (click)="addOption()">
      <vs-icon name="plus"></vs-icon>
      Add Option
    </button>
  </vs-card-header>

  <vs-card-content class="flex flex-col gap-4">
    <p class="text-sm text-gray-600">
      Unspecified is handled automatically when a claim resolution is left blank or set to null.
    </p>

    <div *ngIf="loading" class="text-sm text-gray-500">Loading claim resolution options...</div>

    <div *ngIf="!loading" class="flex flex-col gap-4">
      <div *ngFor="let control of values.controls; let index = index" class="flex gap-3 items-start">
        <vs-input-container class="flex-1">
          <input
            type="text"
            [maxlength]="maxLength"
            [formControl]="control"
            [readonly]="!canEdit"
            placeholder="Resolution option"
          />
        </vs-input-container>

        <button
          *ngIf="canEdit"
          vs-button
          appearance="outline"
          theme="danger"
          [disabled]="saving"
          (click)="removeOption(index)"
        >
          <vs-icon name="trash-01"></vs-icon>
        </button>
      </div>

      <p *ngIf="hasDuplicateValues" class="text-sm text-danger-600">Resolution values must be unique.</p>

      <div class="flex flex-col-reverse sm:flex-row sm:justify-end items-center gap-3" *ngIf="canEdit && form.dirty">
        <button
          vs-button
          class="sm:flex-none w-full sm:w-fit"
          appearance="outline"
          [disabled]="saving"
          (click)="reset()"
        >
          Cancel
        </button>

        <button
          vs-button
          class="sm:flex-none w-full sm:w-fit"
          theme="primary"
          [disabled]="saving || form.invalid || hasDuplicateValues"
          (click)="save()"
        >
          Save
        </button>
      </div>
    </div>
  </vs-card-content>
</vs-card>
